// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vdvQ","question":"styles_question__1FU2D","inputVisibleButton":"styles_inputVisibleButton__2cGOO","note":"styles_note__1SkLX"};